import { useState, useEffect } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { Menu, X, MessageCircle } from "lucide-react";
import { Button } from "./ui/button";

const LOGO_URL = "https://customer-assets.emergentagent.com/job_one-guy-agency/artifacts/caw3knqv_logo%20arp%202026_mono_branca.png";
const WHATSAPP_LINK = "https://api.whatsapp.com/send/?phone=5508000155555&text&type=phone_number&app_absent=0";
const PHONE_DISPLAY = "0800 015 5555";

const navLinks = [
  { href: "#solucoes", label: "Soluções", id: "solucoes" },
  { href: "#planos", label: "Planos", id: "planos" },
  { href: "#svas", label: "SVAs", id: "svas" },
  { href: "#unidades", label: "Unidades", id: "unidades" },
];

const Navbar = () => {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  return (
    <motion.nav
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        isScrolled ? "navbar-glass shadow-lg py-3" : "bg-transparent py-4"
      }`}
      initial={{ y: -100 }}
      animate={{ y: 0 }}
      transition={{ duration: 0.5 }}
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex items-center justify-between">
          {/* Logo */}
          <a href="#" className="flex items-center gap-2" data-testid="navbar-logo">
            <img
              src={LOGO_URL}
              alt="Grupo ARP Logo"
              className="h-24 md:h-28 w-auto object-contain"
            />
          </a>

          {/* Desktop Navigation */}
          <div className="hidden md:flex items-center gap-8">
            {navLinks.map((link) => (
              <a
                key={link.href}
                href={link.href}
                className="text-white/80 font-medium text-sm hover:text-brand-ruby transition-colors"
                data-testid={`nav-link-${link.id}`}
              >
                {link.label}
              </a>
            ))}
            <a href={WHATSAPP_LINK} target="_blank" rel="noopener noreferrer">
              <Button
                className="bg-brand-ruby hover:bg-brand-ruby/90 text-white font-bold px-6 btn-ruby"
                data-testid="navbar-cta-btn"
              >
                <MessageCircle className="w-4 h-4 mr-2" />
                {PHONE_DISPLAY}
              </Button>
            </a>
          </div>

          {/* Mobile Menu Button */}
          <button
            className="md:hidden p-2"
            onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
            data-testid="mobile-menu-toggle"
          >
            {isMobileMenuOpen ? (
              <X className="w-6 h-6 text-white" />
            ) : (
              <Menu className="w-6 h-6 text-white" />
            )}
          </button>
        </div>

        {/* Mobile Menu */}
        <AnimatePresence>
          {isMobileMenuOpen && (
            <motion.div
              className="md:hidden absolute top-full left-0 right-0 bg-brand-dark shadow-lg border-t border-white/10"
              initial={{ opacity: 0, height: 0 }}
              animate={{ opacity: 1, height: "auto" }}
              exit={{ opacity: 0, height: 0 }}
            >
              <div className="flex flex-col p-4 gap-4">
                {navLinks.map((link) => (
                  <a
                    key={link.href}
                    href={link.href}
                    className="text-white font-medium py-2 hover:text-brand-ruby transition-colors"
                    onClick={() => setIsMobileMenuOpen(false)}
                    data-testid={`mobile-nav-link-${link.id}`}
                  >
                    {link.label}
                  </a>
                ))}
                <a href={WHATSAPP_LINK} target="_blank" rel="noopener noreferrer">
                  <Button
                    className="w-full bg-brand-ruby hover:bg-brand-ruby/90 text-white font-bold"
                    data-testid="mobile-cta-btn"
                  >
                    <MessageCircle className="w-4 h-4 mr-2" />
                    {PHONE_DISPLAY}
                  </Button>
                </a>
              </div>
            </motion.div>
          )}
        </AnimatePresence>
      </div>
    </motion.nav>
  );
};

export default Navbar;
